<div class="page-loader">
    <div id="load-image-wrapper">
    </div>
    <div class="progress-bar">
        <div class="line"></div>
        <div class="subline inc"></div>
        <div class="subline dec"></div>
    </div>
</div>